import React, { useState, useEffect, useRef } from "react";
import * as url from "../../../../utils/url";
import axios from "../../../../axios";
import {
  Button,
  Card,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { FaExclamationTriangle } from "react-icons/fa";
import TextSentimentComponentOverall from "./TextSentimentComponentOverall";
import { BiRecycle } from "react-icons/bi";
import parse from "react-html-parser";
import { BsStar, BsStars, BsDownload } from "react-icons/bs";
import EmptyTable from "../../../../components/EmptyTable/EmptyTable";
import TriviaSMSResponses from "./TriviaSMSResponses";
import {
  LayoutHeading,
  LayoutData,
} from "../../../weekly-wins/TableLayoutComponents";
import { LayoutRow } from "../../../../components/TableComponents/RowBordered/RowBordered";
import {
  SENTIMENTS_COLOR_MAP2,
  SENTIMENTS_TYPO_MAP,
  SENTIMENTS_TYPO_MAP2,
  showYou,
} from "../../data";
import { isMobile } from "../../../../utils/deviceInfo";
import { profilePicValidityCheck } from "../../../../utils/constants";
import moment from "moment";
import SeeMoreWrapper from "../../../../components/Shared/SeeMoreWrapper";
import { BsEmojiFrown, BsEmojiSmile, BsEmojiNeutral } from "react-icons/bs";
import "./resultsComponents.css";
import { FaFaceMehBlank } from "react-icons/fa6";
import { FaRegFaceMehBlank } from "react-icons/fa6";
import OoPopover from "../../../../components/UI/Popover/OoPopover";
// import { useNavigate } from "react-router-dom";

// const navigate = useNavigate();
import { withRouter } from "react-router-dom";
import SpinnerLoader from "../../../../components/UI/SpinnerLoader/SpinnerLoader";

import { BiUpArrowAlt, BiDownArrowAlt, BiHide } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { orderBy } from "lodash";

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

function MessagingTriviaResultsResponses({
  trivia,
  user,
  userSubmissions,
  history: routerHistory,
  setNeedsAttentionSortTrigger,
  needsAttentionSortTrigger,
  isFilterLoading,
  ...props
}) {
  const [originalResponsesData, setOriginalResponsesData] = useState([]);
  const [responsesData, setResponsesData] = useState([]);
  const [fullTextModal, setFullTextModal] = useState(null);
  const [sortParams, setSortParams] = useState({ sortBy: "date", sortOrder: "desc" });
  const [dropdownOpenCol, setDropdownOpenCol] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const hasSortedNeedsAttention = useRef(false);
  // Dropdown logic for column menu
  const toggleCol = (col) => {
    setDropdownOpenCol(dropdownOpenCol === col ? null : col);
  };

  const renderDDtab = (col, label) => {
    const isSortedByThisCol = sortParams.sortBy === col;
    const nextSortOrder = isSortedByThisCol && sortParams.sortOrder === "asc" ? "desc" : "asc";

    return (
      <Dropdown isOpen={dropdownOpenCol === col} toggle={() => toggleCol(col)} direction="down">
        <DropdownToggle
          size="sm"
          tag={"span"}
          className="action-table-col-overlap"
          style={{ cursor: "pointer", padding: 0, marginLeft: 6 }}
        >
          <span className="TriviaEditViewListUI_leftContainer_singleQuestion_threedots_wrapper">
            <BsThreeDotsVertical />
          </span>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => { setSortParams({ sortBy: col, sortOrder: nextSortOrder }); setDropdownOpenCol(null); }}>
            {nextSortOrder === 'asc' ?
              <BiUpArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} /> :
              <BiDownArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} />
            }
            {' '}
            Sort
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  const handleFetchUsers = async () => {
    axios
      .get(url.getMessagingResponses(trivia._id))
      .then(({ data }) => {
        console.log("48 --- ", data);
        const dataFormatted = data.data.map((res) => ({
          user: res.userId ? res.userId : res.userData,
          response: res.messagingResponse
            ? res.messagingResponse.text
            : "No response",
          date: res.dateTrivvySent ? res.dateTrivvySent : res.messagingResponse
            ? res.messagingResponse.respondedDate
            : res.createdOn,
          sentimentData:
            res.sentimentsScore && res.sentimentsScore.sentiment
              ? res.sentimentsScore
              : null,
          sentDate: res.isSubmittedDate || '',
          needsAttention: res.needsAttention,
          ...res,
        }));

        setOriginalResponsesData(dataFormatted);
      })
      .catch((err) => {
        console.log(err);
      });
  };


  useEffect(() => {
    handleFetchUsers();
  }, []);


  useEffect(() => {
    if (
      userSubmissions &&
      userSubmissions.length === 1 &&
      userSubmissions[0] === "filter"
    ) {
      handleFetchUsers();
    } else if (userSubmissions && userSubmissions.users) {
      const dataFormatted = userSubmissions.users.map((res) => ({
        user: res.userId,
        response: res.messagingResponse
          ? res.messagingResponse.text
          : "No response",
        date: res.dateTrivvySent ? res.dateTrivvySent : res.messagingResponse
          ? res.messagingResponse.respondedDate
          : res.createdOn,
        sentDate: res.isSubmittedDate || '',
        sentimentData:
          res.sentimentsScore && res.sentimentsScore.sentiment
            ? res.sentimentsScore
            : null,
        needsAttention: res.needsAttention,
      }));
      setOriginalResponsesData(dataFormatted);
    }
  }, [userSubmissions]);

      // Parse URL query params for initial sorting on mount
    useEffect(() => {
      const searchParams = new URLSearchParams(props.location.search);
      const sortBy = searchParams.get('sortBy');
      const sortOrder = searchParams.get('sortOrder');
      if ((!hasSortedNeedsAttention.current || needsAttentionSortTrigger) && sortBy === 'needsAttention' && sortOrder && responsesData && responsesData.length > 0) {
        let list = [...responsesData];
        list = orderBy(list, (itm) => itm.needsAttention ? 1 : 0, [sortOrder]);
        setResponsesData(list);
        hasSortedNeedsAttention.current = true;
        setNeedsAttentionSortTrigger(false);
      }
    }, [responsesData, props.location.search, needsAttentionSortTrigger]);

  // Sorting logic
  useEffect(() => {
    let list = [...originalResponsesData];
    const { sortBy, sortOrder } = sortParams;

    if (!sortBy || !sortOrder) {
      setResponsesData(list);
      return;
    }

    switch (sortBy) {
      case "date":
        list = orderBy(list, (itm) => itm.date ? moment(itm.date).valueOf() : 0, [sortOrder]);
        break;
      case "sentDate":
        list = orderBy(list, (itm) => itm.sentDate ? moment(itm.sentDate).valueOf() : 0, [sortOrder]);
        break;
      case "user":
        list = orderBy(list, (itm) => {
          if (!itm.user) return "";
          const first = itm.user.firstName || "";
          const last = itm.user.lastName || "";
          return (first + " " + last).toLowerCase();
        }, [sortOrder]);
        break;
      case "sentimentData":
        list = orderBy(list, (itm) => {
          if (!itm.sentimentData || !itm.sentimentData.sentiment) return "";
          return SENTIMENTS_TYPO_MAP2[itm.sentimentData.sentiment] || "";
        }, [sortOrder]);
        break;
      case "response":
        list = orderBy(list, (itm) => (itm.response || "").toLowerCase(), [sortOrder]);
        break;
      case "needsAttention":
        list = orderBy(list, (itm) => itm.needsAttention ? 1 : 0, [sortOrder]);
        break;
      case "conversationMessageCount":
        list = orderBy(list, (itm) => itm.conversationMessageCount == null ? 0 : itm.conversationMessageCount, [sortOrder]);
        break;
      default:
        break;
    }
    setResponsesData(list);
  }, [originalResponsesData, sortParams]);

  const sortComponent = (key) => {
    if (
      sortParams.sortBy === key &&
      sortParams.sortOrder === "asc"
    ) {
      return <BiDownArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} />;
    } else if (sortParams.sortBy === key && sortParams.sortOrder === "desc") {
      return <BiUpArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} />;
    } else {
      return null;
    }
  };

  let isDataExists = responsesData && responsesData.length > 0;

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const openChatHistoryModal = (result) => {
    const allResult = {
      ...result,
      comingFromNeedsAttention: true,
    };
    setFullTextModal(allResult);
  };

  if (isFilterLoading) {
    return (
      <div style={{ marginTop: "48px", minHeight: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <SpinnerLoader />
      </div>
    );
  }

  const handleExportCSV = () => {
    setExportLoading(true);
    axios
      .get(url.exportMessagingResponsesCSV(trivia._id))
      .then(function (response) {
        var csvData = response && response.data && response.data.data;
        if (!csvData) {
          setExportLoading(false);
          return;
        }

        var csvRows = [];
        csvRows.push(csvData.headers.join(","));

        if (csvData.rows && csvData.rows.length > 0) {
          for (var i = 0; i < csvData.rows.length; i++) {
            var row = csvData.rows[i].map(function (cell, colIndex) {
              // Columns 1 (Sent Date) and 2 (Response Date) are raw ISO dates — format in browser timezone
              if ((colIndex === 1 || colIndex === 2) && cell) {
                var cellStr = moment(cell).format("lll");
              } else {
                var cellStr = cell === null || cell === undefined ? "" : String(cell);
              }
              if (!cellStr && (colIndex === 1)) cellStr = "N/A";
              if (!cellStr && (colIndex === 2)) cellStr = "-";
              if (cellStr.indexOf(",") !== -1 || cellStr.indexOf('"') !== -1 || cellStr.indexOf("\n") !== -1) {
                cellStr = '"' + cellStr.replace(/"/g, '""') + '"';
              }
              return cellStr;
            });
            csvRows.push(row.join(","));
          }
        }

        var csvString = csvRows.join("\n");
        var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        var downloadUrl = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute(
          "download",
          (trivia.name || "Messaging Trivia") + " - " + moment().format("MM/DD/YYYY") + ".csv"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);
        setExportLoading(false);
      })
      .catch(function (err) {
        console.log("Error exporting CSV:", err);
        setExportLoading(false);
      });
  };

  return (
    <div>
      <Card className="p-3">
        {/* <div>
          {" "}
          <h5>Message Title: </h5>
          <div>
            {" "}
            {trivia.name ? trivia.name : `No title`} */}
        {/* `${trivia.messagingSubject.slice(0, 10)}...` */}
        {/* </div>
        </div> */}
        <h5>
          <strong>{trivia.name ? trivia.name : "No title"}:</strong>{" "}
          {trivia.messagingSubject}
        </h5>
        {/* <div className="mt-4">
          <h5>Message Content:</h5>
          {trivia.messagingSubject}
        </div> */}
      </Card>

      {fullTextModal && (
        <Modal isOpen={true}>
          <ModalHeader
            className="trivia_modal_header_bg"
            toggle={() => setFullTextModal(null)}
          >
            {fullTextModal.user && !fullTextModal.isAnonymous ? (
              <span className="trivia_table_text_wrapper">
                {profilePicValidityCheck(fullTextModal.user.profilePic) ? (
                  <img
                    src={fullTextModal.user.profilePic}
                    height="35px"
                    width="35px"
                    style={{ borderRadius: "50%" }}
                  />
                ) : (
                  <span
                    className="spotlightUserInitials"
                    data-letters={getInitials(fullTextModal.user)}
                  ></span>
                )}{" "}
                <span style={{ fontSize: "22px" }}>
                  {" "}
                  {fullTextModal.user.firstName} {fullTextModal.user.lastName}
                </span>
              </span>
            ) : (
              <span className="trivia_table_text_wrapper">
                <span
                  className="spotlightUserInitials"
                  data-letters={"AU"}
                ></span>
                Anonymous user{" "}
              </span>
            )}{" "}
            Response{" "}
            <OoPopover
              target="messaging_users_full_response_modal"
              headerText="User Info"
              bodyText={
                <div className="messaging_users_full_response_modal_userInfo">
                  {fullTextModal.user && fullTextModal.user.mobileNumber ? (
                    <div>
                      {" "}
                      <b>Mobile Number:</b>
                      <div>{fullTextModal.user.mobileNumber}</div>
                    </div>
                  ) : (
                    ""
                  )}
                  {fullTextModal.user && fullTextModal.user.email ? (
                    <div className="mt-3">
                      {" "}
                      <b>Email:</b>
                      <div> {fullTextModal.user.email}</div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              }
            />
          </ModalHeader>
          <ModalBody className="p-3">
            {/* <div className="my-3">
              <b>User: </b>
              {fullTextModal.user && !fullTextModal.isAnonymous ? (
                <span className="trivia_table_text_wrapper">
                  {profilePicValidityCheck(fullTextModal.user.profilePic) ? (
                    <img
                      src={fullTextModal.user.profilePic}
                      height="35px"
                      width="35px"
                      style={{ borderRadius: "50%" }}
                    />
                  ) : (
                    <span
                      className="spotlightUserInitials"
                      data-letters={getInitials(fullTextModal.user)}
                    ></span>
                  )}{" "}
                <span style={{fontSize:"22px"}}> {fullTextModal.user.firstName} {fullTextModal.user.lastName}</span> 
                </span>
              ) : (
                <span className="trivia_table_text_wrapper">
                  <span
                    className="spotlightUserInitials"
                    data-letters={"AU"}
                  ></span>
                  Anonymous user{" "}
                  {showYou(fullTextModal.profile, fullTextModal) ? "(You)" : ""}
                </span>
              )}
            </div> */}

            <div className="my-3">
              <b>Submitted on:</b> {moment(fullTextModal.date).format("lll")}
            </div>
            {fullTextModal.sentimentData && (
              <div className="my-3 responses-modal-sentiment-analysis-container">
                <b>Sentiment:</b>{" "}
                {fullTextModal.sentimentData.sentiment == "POSITIVE" ? (
                  <span className="sentiment-analysis_positive fw600">
                    <BsEmojiSmile />
                    {
                      SENTIMENTS_TYPO_MAP2[
                      fullTextModal.sentimentData.sentiment
                      ]
                    }
                  </span>
                ) : fullTextModal.sentimentData.sentiment == "NEGATIVE" ? (
                  <span className="sentiment-analysis_negative fw600">
                    <BsEmojiFrown />:
                    {
                      SENTIMENTS_TYPO_MAP2[
                      fullTextModal.sentimentData.sentiment
                      ]
                    }
                  </span>
                ) : fullTextModal.sentimentData.sentiment == "MIXED" ? (
                  <span className="sentiment-analysis_mixed fw600">
                    <FaRegFaceMehBlank />
                    {
                      SENTIMENTS_TYPO_MAP2[
                      fullTextModal.sentimentData.sentiment
                      ]
                    }
                  </span>
                ) : fullTextModal.sentimentData.sentiment == "NEUTRAL" ? (
                  <span className="sentiment-analysis_neutral fw600">
                    <BsEmojiNeutral />
                    {
                      SENTIMENTS_TYPO_MAP2[
                      fullTextModal.sentimentData.sentiment
                      ]
                    }
                  </span>
                ) : (
                  ""
                )}
              </div>
            )}
            <p className="my-3">
              {" "}
              <b>Response: </b> {fullTextModal.response}
            </p>

            <TriviaSMSResponses trivia={fullTextModal} />
          </ModalBody>
        </Modal>
      )}

      <div className="mt-4">
        <div>
          {responsesData.length > 0 ? (
            <>
              <div className="d-flex justify-content-start mb-3">
                <button
                  className="btn messages-export trivia-action-button-main btn-sm"
                  onClick={handleExportCSV}
                  disabled={exportLoading}
                >
                  <span className="export-btn">
                    {exportLoading ? "Exporting..." : "Export CSV"} <BsDownload size={13} />
                  </span>
                </button>
              </div>
              <div className={`actions-table-div results-invidual-table p0`}>
                <LayoutRow
                  className="mobileNoheightActionTable"
                  style={{
                    // minHeight: "400px",
                    backgroundColor:
                      responsesData && responsesData.length > 0
                        ? ""
                        : "#8080802b",
                  }}
                >
                  <Row
                    className="row-scroll-width"
                    style={{
                      width: `100%`,
                      flexWrap: "nowrap",
                    }}
                  >
                  <LayoutHeading
                    className={`p-3 border-gray-thin`}
                    colWidth={2}
                    plainTable
                  >
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      User {renderDDtab("user", "User")}
                    </span>
                  </LayoutHeading>
                  <LayoutHeading
                    className="p-3 border-gray-thin"
                    colWidth={2}
                    plainTable
                  >
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      Sent Date {renderDDtab("sentDate", "Sent Date")}
                    </span>
                  </LayoutHeading>
                  <LayoutHeading
                    className="p-3 border-gray-thin"
                    colWidth={2}
                    plainTable
                  >
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      Response Date {renderDDtab("date", "Response Date")}
                    </span>
                  </LayoutHeading>
                  <LayoutHeading
                    className="p-3 border-gray-thin"
                    colWidth={3}
                    plainTable
                  >
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      Response {renderDDtab("response", "Response")}
                    </span>
                  </LayoutHeading>
                  <LayoutHeading
                    className="p-3 border-gray-thin"
                    colWidth={1}
                    plainTable
                  >
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      Sentiment {renderDDtab("sentimentData", "Sentiment")}
                    </span>
                  </LayoutHeading>
                  <LayoutHeading
                    className="p-3 border-gray-thin"
                    colWidth={1}
                    plainTable
                  >
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      Needs Attention {renderDDtab("needsAttention", "Needs Attention")}
                    </span>
                  </LayoutHeading>
                  <LayoutHeading
                    className="p-3 border-gray-thin"
                    colWidth={1}
                    plainTable
                  >
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      Message History {renderDDtab("conversationMessageCount", "Message History")}
                    </span>
                  </LayoutHeading>
                </Row>

                  <div
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      width: "100%",
                    }}
                  >
                    {responsesData.map((result, i) => {
                      console.log(result, "result");
                      return (
                        <LayoutRow
                          className={`pl-tasks-row row-scroll-width cursor-pointer`}
                          style={{ width: `100%` }}
                          onClick={() => openChatHistoryModal(result)}
                        >
                          <LayoutData
                            className={"border-gray-thin cursor-pointer"}
                            key={i}
                            // onClick={() => {
                            //   setFullTextModal(result);
                            // }}
                            colWidth={2}
                          >
                            {result.user && !result.isAnonymous ? (
                              <span
                                className="trivia_table_text_wrapper"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (
                                    result &&
                                    result.user &&
                                    result.user._id &&
                                    routerHistory &&
                                    routerHistory.push
                                  ) {
                                    routerHistory.push(
                                      `/home/${result.organizationId}/profile/${result.user._id}`
                                    );
                                    // props.history.push(
                                    //    `/home/${result.organizationId}/profile/${result.user._id}`
                                    //  );
                                  }
                                }}
                              >
                                {profilePicValidityCheck(
                                  result.user.profilePic
                                ) ? (
                                  <img
                                    src={result.user.profilePic}
                                    height="35px"
                                    width="35px"
                                    style={{ borderRadius: "50%" }}
                                  />
                                ) : (
                                  <span
                                    className="spotlightUserInitials"
                                    data-letters={getInitials(result.user)}
                                  ></span>
                                )}{" "}
                                {result.user.firstName || result.user.lastName ? (
                                  <>
                                    {result.user.firstName} {result.user.lastName}
                                  </>
                                ) : result.user.email ? (
                                  result.user.email
                                ) : result.user.mobileNumber ? (
                                  result.user.mobileNumber
                                ) : result.user.firstName ||
                                  result.user.lastName ? (
                                  result.user.firstName || result.user.firstName
                                ) : result.user.employeeId ? (
                                  result.user.employeeId
                                ) : result.user.identification ? (
                                  result.user.identification
                                ) : (
                                  ""
                                )}
                              </span>
                            ) : (
                              <span className="trivia_table_text_wrapper">
                                <span
                                  className="spotlightUserInitials"
                                  data-letters={"AU"}
                                ></span>
                                Anonymous user{" "}
                                {showYou(user.profile, result) ? "(You)" : ""}
                              </span>
                            )}
                          </LayoutData>
                          <LayoutData colWidth={2}>
                            <span className={"trivia_table_text_wrapper"}>
                              {moment(result.date).format("lll")}{" "}
                              {/* {new Date(result.date).toLocaleString()} */}
                            </span>
                          </LayoutData>
                                    <LayoutData colWidth={2}>
                                      <span className={"trivia_table_text_wrapper"}>
                                        {result.sentDate ? moment(result.sentDate).format("lll") : "-"}
                                      </span>
                                    </LayoutData>

                          <LayoutData
                            colWidth={3}
                            customStyle={{
                              ...(result.sentimentData && {
                                backgroundColor:
                                  SENTIMENTS_COLOR_MAP2[
                                    result.sentimentData.sentiment
                                  ],
                              }),
                            }}
                          >
                            <div style={{fontSize: '12px'}}>
                              <SeeMoreWrapper
                                text={result.response}
                                limit={80}
                                openModal={() => {
                                  setFullTextModal(result);
                                }}
                              />
                            </div>
                          </LayoutData>

                          <LayoutData
                            colWidth={1}
                            customStyle={{
                              ...(result.sentimentData && {
                                backgroundColor:
                                  SENTIMENTS_COLOR_MAP2[
                                    result.sentimentData.sentiment
                                  ],
                              }),
                            }}
                          >
                            <span className={"trivia_table_text_wrapper"}>
                              {result.sentimentData ? (
                                <div>
                                  {
                                    SENTIMENTS_TYPO_MAP2[
                                      result.sentimentData.sentiment
                                    ]
                                  }
                                </div>
                              ) : (
                                "N/A"
                              )}
                            </span>
                          </LayoutData>

                          <LayoutData
                            colWidth={1}
                            customStyle={{ alignItems: "center" }}
                          >
                            <div>
                              {result.needsAttention ? (
                                <FaExclamationTriangle
                                  color="goldenrod"
                                  size="1.8em"
                                />
                              ) : (
                                "-"
                              )}
                            </div>
                          </LayoutData>

                          <LayoutData
                            colWidth={1}
                            customStyle={{ alignItems: "center" }}
                          >
                            <span style={{fontSize: '12px'}}>{result.conversationMessageCount == 0 ? 1 : result.conversationMessageCount}</span>
                          </LayoutData>
                        </LayoutRow>
                      );
                    })}
                  </div>
                </LayoutRow>
              </div>
            </>
          ) : (
            <div className="d-flex justify-content-center">
              <EmptyTable
                title={"No responses found"}
                subtitle={"No user has submitted any responses yet."}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default withRouter(MessagingTriviaResultsResponses);
